const API_BASE = process.env.REACT_APP_API_URL || '';

export async function apiFetch(path, init = {}) {
  const res = await fetch(`${API_BASE}${path}`, init);
  if (!res.ok) {
    let msg = 'Request failed';
    try {
      const err = await res.json();
      msg = err.error || msg;
    } catch (_) {}
    throw new Error(msg);
  }
  const contentType = res.headers.get('content-type') || '';
  if (contentType.includes('application/json')) return res.json();
  const text = await res.text();
  try { return JSON.parse(text); } catch { return text; }
}


